export default __webpack_public_path__ + "static/media/under_review.311b4a6b.gif";